var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allowEnterStream)?_c('modal-view',{staticClass:"stream-modal",attrs:{"value":true,"closable":false,"scrollable":false}},[_c('consume-controller',{attrs:{"producer":_vm.user,"room-id":_vm.roomId},on:{"close":_vm.onClose}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }